export enum DatePresets {
  Today = 'today',
  Tomorrow = 'tomorrow',
  Friday = 'friday',
  NextWeek = 'next-week',
}

export enum IconOptions {
  Calendar = 'calendar',
  Flag = 'flag',
}
